export function modeEnterDirective() {
  return {
    require: 'ngModel',
    link: function (scope, element, attrs, ctrl: any) {
      element.bind('keydown keypress', function (event) {
        if (event.which === 13) {
          scope.$evalAsync(function () {
            ctrl.$commitViewValue();
          });
          event.preventDefault();
        }
      });
    },
  };
}
